import React from 'react';
import { Text, TextProps } from '../../Text';
import { useCustomComponent } from '@/hooks';

export interface ChatMessageMetaProps extends TextProps {}

const MetaComponent: React.FC<ChatMessageMetaProps> = props => {
  return <Text {...props} />;
};

export const Meta: React.FC<ChatMessageMetaProps> = (
  props: ChatMessageMetaProps
) => {
  const Component = useCustomComponent({
    componentName: 'ChatMessageMeta',
    Component: MetaComponent,
  });

  return <Component {...props} />;
};
